import { render, staticRenderFns } from "./BaseFilePreview.vue?vue&type=template&id=056e4c5d&scoped=true&"
import script from "./BaseFilePreview.vue?vue&type=script&lang=js&"
export * from "./BaseFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e4c5d",
  null
  
)

export default component.exports